import { styled } from 'stitches.config'
import { Text } from 'components/Text'

export const StatisticsRoot = styled('div', {
  width: '100%',
  background: '$accent-white',
  paddingBottom: '100px',
  paddingTop: '30px',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  padding: '64px $2',
  gap: '$3',
  '@bp2': {
    gap: '$4',
    padding: '80px $2',
  },
})

export const StatisticRow = styled('div', {
  zIndex: 2,
  width: '100%',
  maxWidth: '361px',
  margin: 'auto',
  textAlign: 'center',
  borderTop: '1px solid $accent-black',
  padding: '16px 0px',
  '&:last-child': {
    borderBottom: '2px solid $accent-black',
  },
  '&:first-child': {
    borderTop: '2px solid $accent-black',
  },
  '@bp2': {
    margin: 'auto',
    maxWidth: '1072px',
    padding: '16px 0px',
  },
})

export const Subtitle = styled(Text, {
  margin: 'auto',
  width: '100%',
  maxWidth: '290px',
  '@bp2': {
    margin: '12px auto 12px auto',
    maxWidth: 'none',
  },
})

export const Title = styled(Text, {
  width: '100%',
  margin: 'auto',
  maxWidth: '300px',
  zIndex: 1,
  '@bp2': {
    maxWidth: 'none',
  },
})

export const StatisticContainer = styled('div', {})

export const BadgeWrapper = styled('div', {
  position: 'absolute',
  top: '30px',
  left: '0px',
  right: '0px',
  margin: 'auto',
  width: '90px',
  transform: 'translateX(170px)',
  display: 'block',
  zIndex: 0,

  '@bp2': {
    display: 'none',
  },

  '@bp3': {
    transform: 'translateX(530px)',
    display: 'block',
    width: '150px',
  },
})